/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

var CountryItem = function CountryItem(_ref) {
  var isSelected = _ref.isSelected,
      territoryName = _ref.territoryName,
      onHandleSelect = _ref.onHandleSelect,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
  var inputClass = cx({
    disabled: isDisabled
  });
  var labelClass = cx({
    'ContinentItem-disabled': isDisabled,
    'ContinentItem-label': true
  });
  return React.createElement("label", {
    className: labelClass
  }, React.createElement("input", {
    type: "checkbox",
    className: inputClass,
    checked: isSelected,
    onChange: onHandleSelect,
    disabled: isDisabled
  }), territoryName);
};

CountryItem.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool,
  territoryName: PropTypes.string.isRequired,
  onHandleSelect: PropTypes.func.isRequired
};
export default CountryItem;